import { getServiceWorkerRegistration } from "@app/features/subscribe-push/lib/GetServiceWorkerRegistration.tsx";

export async function getPushSubscription() {
	const registration = await getServiceWorkerRegistration();
	if (!registration) {
		log.info("[PUSH] No service worker registered");
		return { success: false, subscription: null };
	}
	return { success: true, subscription: await registration.pushManager.getSubscription() };
}
